import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';
import { AsideComponent } from './aside/aside.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';
import { NopagefoundComponent } from './nopagefound/nopagefound.component';
import { FormsModule } from '@angular/forms';
import { ConfiguracionRoutingModule } from '../configuracion/configuracion-routing.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { ServicesModule } from '../services/services.module';
import { ModalsAgregarLogoComponent } from './sidebar/modals/modals-agregar-logo/modals-agregar-logo.component';



@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    NgSelectModule,
    ServicesModule
  ],
  declarations: [
    SidebarComponent,
    HeaderComponent,
    AsideComponent,
    BreadcrumbsComponent,
    FooterComponent,
    NopagefoundComponent,
    ModalsAgregarLogoComponent
  ],

  exports: [
    HeaderComponent,
    SidebarComponent,
    BreadcrumbsComponent,
    AsideComponent,
    FooterComponent,
    NopagefoundComponent
  ]
})
export class SharedModule { }
